import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../models/role.model';
import { RoleOption } from '../models/role-option.model';

export interface IRolesRepository {
  listManagedRoles(): Observable<readonly RoleOption[]>;
  listRoles(): Observable<readonly Role[]>;
  setPermissions(roleId: number, permissions: readonly string[]): Observable<Role>;
}

export const ROLES_REPOSITORY = new InjectionToken<IRolesRepository>('IRolesRepository');
